import { Box, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTemplate } from "containers/templateDetail/store";
import maxBy from "lodash/maxBy";
import * as React from "react";
import DestinationSelect from "./destinationSelect";
import PriceCalculator from "./priceCalculator";
import PriceDisplay from "./priceDisplay";
import ShippingProfileSelect from "./shippingProfileSelect";
import SwitchModal from "./switchModal";

export const SelectButton = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginTop: 8,
  borderRadius: 4,
  height: 40,
  cursor: "pointer",
  transition: theme.transitions.create([
    "padding-left",
    "padding-right",
    "background-color",
  ]),
  "& svg": {
    transition: theme.transitions.create(["transform"]),
  },
  "&:hover": {
    background: theme.palette.grey[400],
    paddingLeft: 12,
    paddingRight: 12,
    "& .switch-icon": {
      transform: "rotate(180deg)",
    },
  },
}));

export const SelectValue = styled("div")(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  flex: 1,
  width: 0,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
}));

export default function PriceCalculate(): React.ReactElement {
  const { wholesale_group } = useTemplate();
  const [discount, setDiscount] = React.useState(
    wholesale_group
      ? (100 -
          maxBy(wholesale_group.wholesale_price, function (o: any) {
            return o.discount;
          }).discount || 0) / 100
      : 1
  );
  const [quantity, setQuantity] = React.useState(
    wholesale_group
      ? maxBy(wholesale_group.wholesale_price, function (o: any) {
          return o.quantity;
        }).quantity
      : 1
  );

  return (
    <Box
      sx={{
        bgcolor: "grey.200",
        my: 3,
        borderRadius: 1,
        // overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <DestinationSelect />
        <Divider
          flexItem
          orientation="vertical"
          sx={{
            borderColor: "grey.300",
            display: {
              xs: "none",
              md: "block",
            },
          }}
        />
        <Divider
          flexItem
          sx={{
            borderColor: "grey.300",
            display: {
              xs: "block",
              md: "none",
            },
          }}
        />
        <ShippingProfileSelect />
      </Box>
      <Divider flexItem sx={{ borderColor: "grey.300" }} />
      <PriceDisplay quantity={quantity} discount={discount} />
      {wholesale_group && (
        <React.Fragment>
          <Divider flexItem sx={{ borderColor: "grey.300" }} />
          <PriceCalculator
            quantity={quantity}
            setDiscount={setDiscount}
            setQuantity={setQuantity}
          />
        </React.Fragment>
      )}
      <SwitchModal />
    </Box>
  );
}
